import React, { useState, useEffect } from "react";
import { ControlsDropdown } from "./../ControlsDropdown";
import { getBooks } from "api";
import { useExtendedMutation } from "mutations";

const BooksSettingsControls = ({token}) => {
  const [books, setBooks] = useState([]);

  const getSuccessCallback = (data) => {
    setBooks(data);
  }

  const errorCallback = (error) => {
    console.log(error); //TODO add proper error handling
  }

  const getBooksMutation = useExtendedMutation(getBooks, getSuccessCallback, errorCallback);

  useEffect(() => {
    getBooksMutation.mutateOnVirtualThread({token});
  }, [token]);

  return (
    <>
      <ControlsDropdown
        label={"Choose Book"}
        options={books.map(book => book.title)}
        onChange={() => {}}
      />
      <ControlsDropdown
        label={"Choose Chapter"}
        options={["Select A", "B", "C"]}
        onChange={() => {}}
      />
    </>
  );
}

export { BooksSettingsControls }
